import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "../presentation.tsx";
import { Icon, type IconName } from "../icons.tsx";

export type Tone = "neutral" | "brand" | "success" | "warning" | "danger" | "info";
export type BadgeTone = Tone | "restriction";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  /** "soft" tinted background (default) or "solid" fill. */
  variant?: "soft" | "solid";
  icon?: IconName;
  /** A status dot before the label (the label still carries the meaning). */
  dot?: boolean;
  children: ReactNode;
}

/** A short status label. Never colour alone: the text carries the meaning. */
export function Badge({ tone = "neutral", variant = "soft", icon, dot, className, children, ...rest }: BadgeProps) {
  const resolvedIcon = icon ?? (tone === "restriction" ? "restriction" : undefined);
  return (
    <span {...rest} className={cx("pmu-badge", `pmu-badge--${tone}`, variant === "solid" && "pmu-badge--solid", dot && !resolvedIcon && "pmu-badge--dot", className)}>
      {resolvedIcon && <Icon name={resolvedIcon} />}
      {children}
    </span>
  );
}
